import React from 'react';
import { useAuth } from '../../context/AuthContext';

export default function HomeDoctor() {
  const { user } = useAuth();

  return (
    <div className="flex h-full min-h-screen bg-gray-100 m-6 rounded-2xl shadow-2xl p-10">
      
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Bienvenido, Dr. {user?.nombre} {user?.apellidos}
        </h1>
        <p className="text-lg text-gray-600">
          Esta es tu vista como médico.
        </p>
  
    </div>
  );
}
